<template>
  <div class="inequality-analysis">
    <!-- <img alt="Inequality Analysis" src="../assets/sp2lnob/Inequality_Analysis.png" /> -->
    <h3 class="ps-2 pt-2">Inequality in {{ access_or_prevalence.toLowerCase() }} {{ indicatorName.toLowerCase() }} before and after simulation</h3>
    <multi-line-chart v-if="chartData.data.length" :data="chartData" :chart-options="chartOptions"></multi-line-chart>
  </div>
</template>

<script>
import MultiLineChart from '@wc/line-chart/spp-multi-line-chart.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'InequalityAnalysis',
  components: { MultiLineChart },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      indicatorName: '',
      access_or_prevalence: 'Access to',
      chartData: {
        data: [],
        metadata: {
          x_datatype: 'number',
          y_datatype: 'number',
          name: 'Inequality in access',
          color: { 'Without social protection': '#FF9999', 'With social protection': '#33CCCC', Reference: '#222222' }
        }
      },
      chartOptions: {
        width: 960,
        height: 400,
        margin: {
          bottom: 10,
          left: 70,
          right: 70
        },
        rotateX: null, // 45,
        xScaleType: 'scalePoint',
        xField: 'x',
        xLabel: 'Cum. Share of Individuals',
        yField: 'y',
        yLabel: 'Cum. Share of Access',
        isTrend: false,
        showLegend: true,
        // timeFormat: '%Y', // d3.timeParse('%Y-%m-%dT%H:%M:%S%Z'),
        // decimalPoint: setDecimalPointValue,
        decimalPoint: 2,
        yAxisMin: 0,
        strokeThickness: 2,
        // timeLabelFormat: '%Y',
        xUnitLabel: '',
        isHideHorizontalGridLine: true,
        tickFormat: (domain, value) => {
          return this.isDivisible(value, 0.1) ? value : '';
        }
        // isYAxisHideDecimalValue: true,
        // isYAxisHideDomain: true,
        // isShowLineLabel: true,
        // isShowLineNodeLabel: true
      }
    };
  },
  computed: {
    ...mapGetters('analysis', [
      'getSp2lnobConfigs'
    ])
  },
  watch: {
    data: {
      handler: function (data) {
        this.indicatorName = this.getSp2lnobConfigs.detailScenario1.outcome_variable_obj.name || 'Clean Fuel';
        if (this.getSp2lnobConfigs.detailScenario1.outcome_variable_obj.type === 'negative') {
          this.access_or_prevalence = 'Prevalence of';
          this.chartOptions.yLabel = 'Cum. Share of Prevalence';
        } else {
          this.access_or_prevalence = 'Access to';
          this.chartOptions.yLabel = 'Cum. Share of Access';
        }
        // Set to get unique objects
        const setObj = new Set(data.map(JSON.stringify));
        const uniqueData = Array.from(setObj).map(JSON.parse);
        uniqueData.sort((a, b) => a.p < b.p);
        const categories = [...new Set(uniqueData.map(d => d.category))];
        // console.log(categories);
        const newChartData = [];
        for (const cate of categories) {
          const oneCateData = {
            label: (cate === 'Current') ? 'Without social protection' : 'With social protection',
            data: uniqueData.filter(d => d.category === cate).map(d => ({ x: d.p, y: d.L }))
          };
          newChartData.push(oneCateData);
        }
        const refinedData = [];
        // console.log(newChartData[1].data.length);
        // console.log(newChartData[0].data.map(cd => cd.x));
        for (const sd of newChartData[1].data) {
          if (newChartData[0].data.map(cd => cd.x).includes(sd.x)) {
            // console.log(sd);
            refinedData.push(sd);
          }
        }
        newChartData[1].data = refinedData;
        // console.log(newChartData[1].data.length);
        const refData = {
          label: 'Reference',
          data: uniqueData.filter(d => d.category === categories[0]).map(d => ({ x: Math.round(d.L), y: Math.round(d.L) }))
        };
        newChartData.push(refData);
        this.chartData.data = newChartData;
        this.chartData = JSON.parse(JSON.stringify(this.chartData));
      }
    }
  },
  methods: {
    isDivisible: function (value, divisor, epsilon = 1e-10) {
      return Math.abs(Math.round(value / divisor) * divisor - value) < epsilon;
    }
  }
};
</script>

<style lang="css" scoped>
.inequality-analysis img {
  width: 100%;
}
</style>
